import {usaStates, canadianProvincesAndTerritories} from "utils/constants"
import { LocationIcon } from "components/assets/Icons";

// formated list of destinations
export const formattedUSStates = usaStates.map(state => {
  return {
      value: state.value,
      label: `${state.value} - ${state.label}`
  };
});

export const formattedCanadianProvinces = canadianProvincesAndTerritories.map(province => {
  return {
      value: province.value,
      label: `${province.value} - ${province.label}`
  };
});

  // find states for destination from API
  export const preparedSelected = (data) => {
    let result = []
    data?.forEach(el => {
       let fromUS = formattedUSStates.filter((item) => item.value === el)
       let fromCanada = formattedCanadianProvinces.filter((item) => item.value === el)
       result.push(...fromUS, ...fromCanada)
    })
    return result
  }

  // check height for styles update 
  export const availHeight = +window.visualViewport.height;

  // destinaton 
  export const destinationRenderer = (selected) => {
    if (!selected.length) {
      return <LocationIcon />;
    }

    if (selected.length > 1 &&selected.length < 10 ) {
      return (
        <>
          <LocationIcon />
          {`${selected.map((item) => ` ${item.value}`)} `}
        </>
      );
    } if (selected.length >= 10) {
      return (
        <>
          <LocationIcon />
          {`${selected.length} selected`}
        </>
      );
    }else if (selected.length === 1) {
      return (
        <>
          <LocationIcon />
          {selected[0]?.value}
        </>
      );
    }
  };

  export const preparedDestination = (data) => {
    let result = []
    data.length && data.forEach((item) => {
      result.push(item.value)
    }) 
    return result.length ? result.toString() : null
  }

  export function generateString(obj) {
    let result = '';
  
    // Iterate over the object properties
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        // Get the array corresponding to the current key
        const dataArray = obj[key];
        
        // Iterate over the array and concatenate the value with data from the array
        dataArray.forEach((dataValue) => {
          result += `${key} - ${dataValue}\n`;
        });
      }
    }
  
    return result;
  }
  